import axios from "../AxiosInterCeptor/AxiosInterCeptor";

const URL = process.env.React_App_BaseUrl;

// History is a read-only side feature: callers render their own empty/error
// states, so these never toast and always resolve to an object.
const get = (path, params) =>
  axios
    .get(`${URL}/master-history${path}`, { params })
    .then((response) => response.data || { error: true, message: "Empty response" })
    .catch((error) => ({
      error: true,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Could not reach the server",
    }));

const segment = (value) => encodeURIComponent(String(value));

const GetMasterHistoryConfig = () => get("/config");

const GetMasterHistoryEntities = () => get("/entities");

const GetMasterChangeLog = (params) => get("", params);

const GetMasterRecordHistory = (entityType, entityId) =>
  get(`/${segment(entityType)}/${segment(entityId)}`);

const GetMasterRecordVersion = (entityType, entityId, version) =>
  get(`/${segment(entityType)}/${segment(entityId)}/versions/${segment(version)}`);

const GetMasterRecordAsOf = (entityType, entityId, date) =>
  get(`/${segment(entityType)}/${segment(entityId)}/as-of`, { date });

export {
  GetMasterHistoryConfig,
  GetMasterHistoryEntities,
  GetMasterChangeLog,
  GetMasterRecordHistory,
  GetMasterRecordVersion,
  GetMasterRecordAsOf,
};
